import {graphql} from 'react-relay';

const exportInvoiceModalQuery = graphql`
	query ExportInvoiceModal_Query(
		$invoiceId: ID
		$billToId: ID
		$xeroInvoicingImprovements: Boolean!
		$qboInvoicingImprovements: Boolean!
	) {
		viewer {
			actualPersonId
			component(name: "export_invoice_modal")
			...ExportInvoiceModal_Viewer
				@arguments(
					invoiceId: $invoiceId
					billToId: $billToId
					xeroInvoicingImprovements: $xeroInvoicingImprovements
					qboInvoicingImprovements: $qboInvoicingImprovements
				)
		}
	}
`;

export {exportInvoiceModalQuery};

export const exportInvoiceModalFragment = {
	viewer: graphql`
		fragment ExportInvoiceModal_Viewer on Viewer
		@argumentDefinitions(
			invoiceId: {type: "ID"}
			billToId: {type: "ID"}
			xeroInvoicingImprovements: {type: "Boolean!", defaultValue: false}
			qboInvoicingImprovements: {type: "Boolean!", defaultValue: false}
		) {
			id
			backendId
			company {
				id
				qboExportDefaultInvoiceRef
				qboExportDefaultDescription
				qboExportDefaultProjectNameInDesc
				qboExportDefaultTerms
				qboExportDefaultTax
				billFroms {
					id
					integration
					externalId
					exportProjectInDescription
					qboAutomatedSalesTax @include(if: $qboInvoicingImprovements)
				}
			}
			billTo(id: $billToId) {
				id
				name
				externalId
				# T4-222: the Bill To's own default, requested only with the Xero improvements flag on.
				xeroDefaultTaxRate @include(if: $xeroInvoicingImprovements) {
					name
					effectiveRate
					organisation
					externalId
				}
				billFrom {
					id
					name
					integration
					externalId
					exportProjectInDescription
					qboAutomatedSalesTax @include(if: $qboInvoicingImprovements)
				}
			}
			invoice(id: $invoiceId) {
				id
				invoiceReference
				companyInvoiceId
				name
				currency
				invoiceType
				status
				dueDay
				dueMonth
				dueYear
				createdDay
				createdMonth
				createdYear
				notes
				quickbooksId
				xeroId
				economicId
				client {
					id
					name
					# T4-188: requested only with the QuickBooks improvements flag on, as T4-197 does for Xero (D8).
					quickbooksCustomerId @include(if: $qboInvoicingImprovements)
					qboDefaultTaxRate @include(if: $qboInvoicingImprovements) {
						name
						effectiveRate
						organisation
					}
					# Requested only with the Xero improvements flag on: flag-off windows send today's query (D8).
					xeroDefaultTaxRate @include(if: $xeroInvoicingImprovements) {
						name
						effectiveRate
						organisation
						externalId
					}
					xeroContactId @include(if: $xeroInvoicingImprovements)
				}
				entries(first: 100000000) {
					edges {
						node {
							id
							name
							quantity
							quantityText
							unitPrice
							discount
							tax
							description
							quantityLockedReason
							project {
								id
								customProjectId
								companyProjectId
								name
								projectColor
								isInProjectGroup
								budgetType
								client {
									name
								}
								rateCard {
									currency
								}
							}
						}
					}
				}
			}
		}
	`,
};
